export const ApiSkills = {
    get: params => ({
        url: '/skills',
        method: 'GET',
        params
    }),
    create: data => ({
        url: '/skills',
        method: 'POST',
        data
    }),
    delete: (id) => ({
        url: `/skills/${id}`,
        method: 'DELETE',
    })
};